// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_9n-0";